<template>
    <div class="sms-campaigns">

        <!-- Título / Breadcrumbs / Botões -->
        <mu-row justify-content="center" align-items="center">
            <mu-col span="6" sm="6" md="6" lg="6" xl="6">

                <!-- Título da página -->
                <mu-title color="secondary" textStrong="700">Campanhas</mu-title>

                <!-- Breadcrumbs -->
                <mu-breadcrumbs divider="—">
                    <font-awesome-icon icon="chevron-right" slot="divider" class="icon-sm icon-margin-right"/>
                    <mu-breadcrumbs-item v-for="item in breadcrumbs" :key="item.text" :to="{ name: item.route }" :disabled="item.disabled">{{ item.text }}</mu-breadcrumbs-item>
                </mu-breadcrumbs>
            </mu-col>
            <mu-col span="6" sm="6" md="6" lg="6" xl="6" class="is-right">

                <!-- Submenu -->
                <mu-submenu :submenu="submenu"></mu-submenu>
            </mu-col>
        </mu-row>

        <br>

        <div class="box-filter">
            <mu-paper :z-depth="1">
                <mu-date-input v-model="filter.date_start" label="Data Inicial" format="DD-MM-YYYY" no-display></mu-date-input>
                <mu-date-input v-model="filter.date_end" label="Data Final" format="DD-MM-YYYY" no-display class="ml-1"></mu-date-input>
                <mu-text-field v-model="filter.title" label="Filtre por título" @keyup.enter="load()" class="ml-1"></mu-text-field>
                <mu-select label="Status" v-model="filter.date_to.selected" class="ml-1">
                    <mu-option v-for="(item, key) in filter.date_to.list" :key="key" :label="item.label" :value="item.value"></mu-option>
                </mu-select>
                <mu-button color="primary" round @click="load()" class="ml-1">Filtrar</mu-button>
                <mu-button round @click="filterClear()" class="ml-1">Limpar</mu-button>
            </mu-paper>
        </div>

        <br>

        <div v-if="!campaigns.loading">

            <!-- Lista das campanhas -->
            <div v-if="campaigns.list.length > 0">
                <mu-campaign-card v-for="(item, key) in campaigns.list" :key="key" :item="item"></mu-campaign-card>
            </div>
            <div v-else class="campaign-empty">
                <font-awesome-icon icon="search" size="3x" />
                <br>
                Nenhuma campanha encontrada.
            </div>

            <!-- Paginação -->
            <mu-flex class="paginate" justify-content="center" v-if="campaigns.paging.total > campaigns.paging.size">
                <mu-pagination :total="campaigns.paging.total" :page-count="5" :page-size="campaigns.paging.size" :current.sync="campaigns.paging.page" @change="load()"></mu-pagination>
            </mu-flex>

        </div>

        <!-- Loading -->
        <mu-loading text="Carregando a lista de campanhas" v-if="campaigns.loading"></mu-loading>

    </div>
</template>

<script>
    import CampaignsServices from '@/services/services/sms'
    import moment from 'moment'

    export default {
        name: 'app-campaigns-dashboard',

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                breadcrumbs: [
                    {
                        text: 'Serviços',
                        route: 'app.services',
                        disabled: false
                    },
                    {
                        text: 'Campanhas',
                        disabled: true
                    }
                ],
                submenu: [
                    {
                        name: 'Criar Campanha',
                        icon: 'plus',
                        route: 'app.services.sms.create',
                        color: 'primary',
                        textColor: null
                    },
                    {
                        name: 'Criar Campanha Com Variáveis',
                        icon: 'plus',
                        route: 'app.services.sms.create.variables',
                        color: 'secondary',
                        textColor: null
                    }
                ],
                filter: {
                    title: '',
                    date_start: new Date().toISOString().slice(0, 10),
                    date_end: new Date().toISOString().slice(0, 10),
                    date_to: {
                        selected: 'all',
                        list: [
                            { label: 'Todas', value: 'all' },
                            { label: 'Agendadas', value: 'scheluded_to' },
                            { label: 'Enviadas', value: 'sented_at' },
                            { label: 'Deletadas', value: 'deleted_at' }
                        ]
                    }
                },
                campaigns: {
                    loading: false,
                    paging: {
                        page: 1,
                        size: 10,
                        total: 0
                    },
                    list: []
                }
            }
        },

        // ╔═╗╦═╗╔═╗╔═╗╔╦╗╔═╗╔╦╗
        // ║  ╠╦╝║╣ ╠═╣ ║ ║╣  ║║
        // ╚═╝╩╚═╚═╝╩ ╩ ╩ ╚═╝═╩╝

        /**
         * Acessamos o load para carregar a lista de contato assim que
         * o componente é montado
         */
        created () {
            this.filterClear()
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {

            /**
             * Carrega a lista de auditoria passando a paginação
             */
            async load () {
                try {
                    this.campaigns.loading = true

                    let result = await CampaignsServices.findAll({
                        title: this.filter.title,
                        date_start: moment(this.filter.date_start).format('YYYY-MM-DD'),
                        date_end: moment(this.filter.date_end).format('YYYY-MM-DD'),
                        date_to: this.filter.date_to.selected,
                        page: this.campaigns.paging.page
                    })

                    if (result && result.status) {
                        this.campaigns.paging.page = result.currentPage
                        this.campaigns.paging.total = result.rowCount
                        this.campaigns.list = result.results
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar a listagem de campanhas.')
                } finally {
                    this.campaigns.loading = false
                }
            },

            filterClear () {
                this.filter.title = ''
                this.filter.date_start = moment().add(-7, 'days').format('YYYY-MM-DD')
                this.filter.date_to.selected = 'all'
                this.campaigns.paging.page = 1
                this.load()
            }
        }
    }
</script>

<style lang="stylus" scoped>

    .paginate
        padding 20px

    .campaign-empty
        text-align center
        padding 30px 0

        i
            font-size 40px

    .box-filter
        text-align center
        .mu-paper
            padding 10px 20px 20px 20px
        .mu-input
            margin-bottom 0
            width 100%
        .mu-right-space
            margin-right 10px

    /* Tablet >= 768 pixels */
    @media (min-width: 768px)
        .box-filter
            text-align left
            .mu-input
                width 256px !important

        .ml-1
            margin-left 10px
</style>
